import React, {
  createRef,
  CSSProperties,
  ReactElement,
  useEffect,
  useState,
} from 'react';
import stepCircle from '../../assets/images/step_circle.svg';
import stepTick from '../../assets/images/step_tick.svg';
import {makeid} from '../../core/utils/string.util';
import {useLocation} from 'react-router-dom';
import './Stepper.css';

// type StepperStepProps = {
//   title: string;
//   isFirst?: boolean;
//   isLast?: boolean;
//   icon?: React.ReactNode;
// };
// const StepperStep: React.FC<StepperStepProps> = ({
//   title,
//   isFirst,
//   isLast,
//   icon,
// }: StepperStepProps): ReactElement => {
//   const ref = createRef();
//   const elId = makeid(6);
//   const [styles, setStyles] = useState<CSSProperties>();

//   useEffect(() => {
//     console.log(
//       (ref.current as HTMLDivElement).id +
//         ' ' +
//         (ref.current as HTMLDivElement).offsetWidth,
//     );
//     if (isFirst) {
//       setStyles({
//         transform: 'translateX(-50%)',
//       });
//     }
//     if (isLast) {
//       setStyles({
//         transform: 'translateX(50%)',
//       });
//     }
//     return () => {
//       console.log('ejected');
//     };
//   }, []);
//   return (
//     <div
//       ref={ref as React.RefObject<HTMLDivElement>}
//       id={elId}
//       className={`grid items-center hello ${
//         isFirst || isLast ? 'flex-grow-0' : 'flex-grow'
//       } place-items-center h-full`}
//       style={styles}>
//       {icon}
//       {/* <img src={stepCircle} /> */}
//       {/* <svg
//         xmlns="http://www.w3.org/2000/svg"
//         className="h-6 w-6"
//         fill="none"
//         viewBox="0 0 24 24"
//         stroke="currentColor">
//         <path
//           strokeLinecap="round"
//           strokeLinejoin="round"
//           strokeWidth={2}
//           d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
//         />
//       </svg> */}
//       <span className="text-xs">{title}</span>
//     </div>
//   );
// };

const Stepper: React.FC = (): ReactElement => {
  const [firstIcon, setFirstIcon] = useState(<img src={stepCircle} />);
  const [secondIcon, setSecondIcon] = useState(<img src={stepCircle} />);
  const [thirdIcon, setThirdIcon] = useState(<img src={stepCircle} />);
  const location = useLocation();
  console.log(location.pathname);

  useEffect(() => {
    if (location.pathname === '/checkout/shoppingbag') {
      setFirstIcon(<img src={stepTick} />);
    } else if (location.pathname === '/checkout/payment') {
      setFirstIcon(<img src={stepTick} />);
      setSecondIcon(<img src={stepTick} />);
    } else if (location.pathname === '/checkout/confirm') {
      setFirstIcon(<img src={stepTick} />);
      setSecondIcon(<img src={stepTick} />);
      setThirdIcon(<img src={stepTick} />);
    }
  }, []);
  return (
    <div>
      <p className="divided px-8">
        <span>{firstIcon}</span>
        <span className="divider"></span>
        <span>{secondIcon}</span>
        <span className="divider"></span>
        <span>{thirdIcon}</span>
      </p>
      <p className="divided px-4">
        <span className="ml-2.5 text-royal_blue font-roboto text-small">
          Bag
        </span>
        <span className="dividers"></span>
        <span className="ml-2 text-royal_blue font-roboto text-small">
          Payment
        </span>
        <span className="dividers"></span>
        <span className="-ml-2.5 text-royal_blue font-roboto text-small">
          Confirm
        </span>
      </p>
    </div>
    // <div className="w-full h-12 bg-transparent relative">
    //   <div className="absolute flex z-20 top-2 bottom-0 right-0 left-0">
    //     <StepperStep title="Bag" isFirst={true} icon={firstIcon} />
    //     <StepperStep title="Payment" icon={secondIcon} />
    //     <StepperStep title="Confirm" isLast={true} icon={thirdIcon} />
    //   </div>
    //   <div className="h-1 absolute top-5 bottom-6 left-0 right-0 bg-blue-600 z-0">
    //     &nbsp;
    //   </div>
    // </div>
    // <div id="status-buttons" className="text-center">
    //   <a href="#/form/regalo" className="active">
    //     <span>1</span> Bag
    //   </a>
    //   <a href="#/form/tusdatos">
    //     <span>2</span> Payment
    //   </a>
    //   <a href="#/form/tusdatos">
    //     <span>3</span> Confirm
    //   </a>
    // </div>
  );
};
export default Stepper;
